import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import languageDetector from 'i18next-browser-languagedetector';

// Configurazione di i18next
i18n
  .use(languageDetector) // Rilevamento automatico della lingua
  .use(initReactI18next) // Inizializzazione di react-i18next
  .init({
    fallbackLng: 'en', // Lingua di fallback se la lingua rilevata non è supportata
    debug: true,
    interpolation: {
      escapeValue: false, // Non necessario in React
    },
    resources: {
      en: {
        translation: {
          "home": {
            "title": "For over 40 years, we have been collaborating with the major sports brands.",
            "description": "Discover our products and services."
          },
          "navbar": {
            "home": "Home",
            "about": "About Us",
            "contact": "Contact",
            "brands": "Brands",
            "services": "Services"
          },
          "about": {
            "title": "About Us",
            "content": {
              "intro": "Galimberti Rappresentanze was born from Ernesto Galimberti's great passion for cycling, a love he passed on to his son Lorenzo, along with his enthusiasm for sports.",
              "history": "Since the early 1980s, GALIMBERTI RAPPRESENTANZE has been operating in northern Italy as a representation agency.",
              "experience": "With over 40 years of activity and a well-established client portfolio, the agency has been involved in the commercial distribution of major brands associated with cycling and sports.",
              "brands": "Major brands such as Gore Bike Wear, Gore Running Wear, Wilier Triestina, Miche, Selle Royal, Continental, Fizik, Crank Brothers, Kask, and Roto have left their mark on the history of cycling."
            }
          },
          "services": {
            "title": "Our Services",
            "details": [
              {
                "title": "Consulting and Sales",
                "body": "We collaborate with leading brands to ensure innovative and competitive solutions. Our goal is to build trust-based relationships, supporting our clients' success in the market."
              },
              {
                "title": "Training & Clinics",
                "body": "According to the standards set by manufacturers, we provide training and clinics on purchased and resold products, supporting consumers during the purchasing process."
              },
              {
                "title": "Local Market Expertise",
                "body": "For over 40 years, we have been creating value in Northern Italy, representing top-quality brands with dedication and competence. Our experience allows us to anticipate market needs, offering tailored and practical solutions."
              },
              {
                "title": "Back Office and Customer Service",
                "body": "Our service is designed to listen and respond with customized solutions, anticipating needs and adding value to every interaction."
              },
              {
                "title": "Showroom",
                "body": "Our showroom is a space dedicated to selling and showcasing our products, designed to host meetings with clients and partners. Here, every customer can explore our latest innovations and discover customized solutions for their needs. A professional environment to foster relationships and business opportunities."
              }
            ]
          },
          "contact": {
            "title": "Contact",
            "address": {
              "title": "Address",
              "street": "Via Brusuglio, 44",
              "citofono": "Intercom 120",
              "city": "20161 - MILAN (IT)",
              "phone": "Tel: +39 02.49469659",
              "email": "Email: info@galimbertirappresentanze.it"
            },
            "directions": {
              "title": "Directions",
              "details": "From the A4 Highway exit, head towards Milan and take Viale Rubicone in the direction of Milan. After approximately 3 km, turn right at the first traffic light onto Via Brusuglio. After 200 meters, you will find number 44 on the right."
            },
            "openingHours": {
              "title": "Opening Hours",
              "details": "Monday - Friday\n9:00 am - 6:00 pm"
            }
          },
          "brands": {
            "title": "Brands",
            "showByRegion": "Show brands by region",
            "showAll": "Show all brands list"
          }
        }
      },
      it: {
        translation: {
          "home": {
            "title": "Da oltre 40 anni, collaboriamo con i grandi marchi dello sport.",
            "description": "Esplora i nostri prodotti e servizi."
          },
          "navbar": {
            "home": "Home",
            "about": "Chi siamo",
            "contact": "Contatti",
            "brands": "Brands",
            "services": "Servizi"
          },
          "about": {
            "title": "Chi siamo",
            "content": {
              "intro": "Galimberti Rappresentanze nasce dalla grande passione per il ciclismo di Ernesto Galimberti, papà di Lorenzo al quale ha trasmesso l’amore per la bicicletta e la passione per lo sport.",
              "history": "Sin dai primi anni 80, GALIMBERTI RAPPRESENTANZE opera nel nord Italia come agenzia di rappresentanza.",
              "experience": "Con oltre 40 anni di attività ed un consolidato portafoglio clienti, l’agenzia nel tempo ha operato nella diffusione commerciale di grandi marchi legati al mondo del ciclismo e dello sport.",
              "brands": "Grandi marchi come Gore Bike Wear, Gore Running Wear, Wilier Triestina, Miche, Selle Royal, Continental, Fizik, Crank Brothers, Kask e Roto hanno lasciato le loro impronte nella storia del ciclismo."
            }
          },
          services: {
            title: "I nostri servizi",
            details: [
              {
                title: "Consulenza e vendita",
                body: "Collaboriamo con marchi leader per garantire soluzioni innovative e competitive. Il nostro obiettivo è costruire relazioni di fiducia, supportando il successo dei nostri clienti sul mercato."
              },
              {
                title: "Training & Clinic",
                body: "Secondo gli standard richiesti dalle case madri offriamo servizi di formazione e clinic sui prodotti acquistati e rivenduti supportando il consumatore nella fase di acquisto."
              },
              {
                title: "Conoscenza del territorio",
                body: "Da oltre 40 anni costruiamo valore nel Nord Italia, rappresentando marchi d'eccellenza con impegno e competenza. La nostra esperienza ci permette di anticipare le esigenze del mercato, offrendo soluzioni concrete e personalizzate."
              },
              {
                title: "Back office e Customer service",
                body: "Il nostro servizio è pensato per ascoltare e rispondere con soluzioni su misura, anticipando le esigenze e dando valore a ogni interazione."
              },
              {
                title: "Showroom",
                body: "Il nostro showroom è uno spazio dedicato alla vendita e all'esposizione dei nostri prodotti, pensato per accogliere meeting con clienti e partner. Qui, ogni cliente può esplorare le nostre ultime novità e scoprire soluzioni personalizzate per le proprie esigenze. Un ambiente professionale per stimolare relazioni e opportunità di business."
              }
            ]
          },
          "contact": {
            "title": "Contatti",
            "address": {
              "title": "Indirizzo",
              "street": "Via Brusuglio, 44",
              "citofono": "Citofono 120",
              "city": "20161 - MILANO (IT)",
              "phone": "Tel: +39 02.49469659",
              "email": "Email: info@galimbertirappresentanze.it"
            },
            "directions": {
              "title": "Indicazioni",
              "details": "Dallo Svincolo Autostrada A4 Uscire in direzione Milano prendere Viale Rubicone direzione Milano. Dopo circa 3 km al primo semaforo svoltare a destra su Via Brusuglio. Dopo 200 mt sulla destra trovate il numero 44."
            },
            "openingHours": {
              "title": "Orari di Apertura",
              "details": "Lunedi - Venerdi\n9:00 am - 18:00 pm"
            }
          },
          "brands": {
            "title": "Brands",
            "showByRegion": "Mostra i brands per regione",
            "showAll": "Mostra l'elenco dei brands"
          }
        }
      }
    }
  });

export default i18n;
